<template  >
    <section class="background-gradiente">
        <menu-top-template :titulo="tituloConta" :icone="iconeWallet" :onPressedClose="voltar"/>

        <!-- <div style="width: 50%; z-index: 12345;">
            <input type="number" v-model="numeroCartaoDigitado" onchange="">
            <button @click="() => onBarcodeLido(this.numeroCartaoDigitado)">Enviar</button>
        </div> -->
        <div v-if="habilitarCodeScanner">
            <CameraScanner @onBarcodeLido="onBarcodeLido"/>
        </div>
  
        <div v-if="!habilitarCodeScanner" class="card-pagina" style="margin: 5px; padding: 10px; border:var(--cor1) 6px solid">
            <!-- <button class="btn-fechar-top" type="button" @click="voltar">
                <img src="../assets/icons/close-red-50.png" alt="">
            </button> -->
            <h2 style="color: black;">CONTA</h2>
            <!-- <p class="titulo">{{ this.$store.state.nomeTerminal }}</p> -->

            <!-- <div style="display: flex" >
                <div v-if="!porCartao" class="coluna">
                    <p>MESA</p>
                    <img  v-if="loading" src="../assets/loading.gif" alt="" style="height: 30px" />
                    <h5  v-if="!loading">{{this.mesa}}</h5>
                </div>
                <div v-if="porCartao" class="coluna">
                    <p>COMANDA</p>
                    <img  v-if="loading" src="../assets/loading.gif" alt="" style="height: 30px" />
                    <h5  v-if="!loading">{{this.numeroCartao}}</h5>
                </div>
                <div class="coluna">
                    <p>STATUS</p>
                    <img  v-if="loading" src="../assets/loading.gif" alt="" style="height: 30px" />
                    <h5 v-if="!loading" style='color: green'>{{this.status}}</h5>
                </div>
                <div class="coluna">
                    <p>TOTAL</p>
                    <img  v-if="loading" src="../assets/loading.gif" alt="" style="height: 30px" />
                    <h5 v-if="!loading" style='color: green'>R$ {{valorArrumado}}</h5>

                    <img  v-if="loading" src="../assets/loading.gif" alt="" style="height: 30px" />
                    <h5 v-if="!loading" style='color: rgb(250, 100, 220);'>R$ {{descontoComandaArrumado}}</h5>
                </div>
            </div> -->


            <div>
                <div v-if="loading"  style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100px;">
                    <img  src="../assets/loading.gif" alt="" style="height: 30px" />
                </div>

                <div  v-if="!loading" style="display: block; width: 100%;">
                    <div style="display: flex; margin-block: 9px; justify-content: space-between; align-items: center;"  v-if="!porCartao" >
                        <p>MESA</p>
                        <p style="font-weight: bold; font-size: 16px; color: black;">{{this.mesa}}</p>
                    </div>

                    <div style="display: flex; margin-block: 9px; justify-content: space-between; align-items: center;"  v-if="porCartao" >
                        <p>COMANDA</p>
                        <p style="font-weight: bold; font-size: 16px; color: black;">{{this.numeroCartao}}</p>
                    </div>

                    <div style="display: flex; margin-block: 9px; justify-content: space-between; align-items: center;">
                        <p>STATUS</p>
                        <p style="font-weight: bold; font-size: 16px; color: black;">{{this.status}}</p>
                    </div>
                    
                    <div style="display: flex; margin-block: 9px; justify-content: space-between; align-items: center;" v-if="descontoComandaArrumado != null">
                        <p>DESCONTO</p>
                        <p style='font-weight: bold; font-size: 16px; color: rgb(250, 100, 220);'>R$ {{descontoComandaArrumado}}</p>
                    </div>

                    <div style="display: flex; margin-block: 9px; justify-content: space-between; align-items: center;">
                        <p>TOTAL</p>
                        <p style='font-weight: bold; font-size: 16px; color: green'>R$ {{valorArrumado}}</p>
                    </div>
                </div>
            </div>


            <!-- loading para itens  -->
            <div v-if="this.loadingItens == true && this.valor > 0.0" style="margin-block: 80px;">
                <p style="margin-bottom: 10px;">Carregando itens</p>
                <img  src="../assets/loading.gif" alt="" style="height: 50px" />
            </div>

            <!-- os itens  -->
            <div v-if="this.itensDaConta != null && this.loadingItens == false && this.valor > 0.0" style="margin-top: 20px;">
                <hr>
                <!-- <h4 style="color: black">Itens</h4> -->

                <div  v-for="(item, index) in this.itensDaConta" :key="index" > 
                    <div style="display: flex; border-radius: 8px; min-height: 40px; box-shadow: 2px 3px 2px 3px  rgba(0,0,0,0.2); margin-bottom: 10px; align-items: center; padding: 7px;">
                        <p style="color: black; font-size: 16px; font-weight: bold;">{{ item.quantidade }} x</p>
                        <div style="display: block; flex: 1; padding-inline: 10px; text-align: start;">
                            <p style="color: rgb(0, 0, 200); font-size: 14px; font-weight: bold;">{{ item.descricaoItem }}</p>
                            <p v-if="item.quantidade > 1">Valor unitário: R$ {{ item.valorUnitario.toFixed(2).replace(".", ",") }}</p>
                            <p v-if="item.descontoItem != null && item.descontoItem > 0" style="color: rgb(250, 100, 220);">Desconto: R$ {{ item.descontoItem.toFixed(2).replace(".", ",") }}</p>
                            <p>{{ item.observacao }}</p>
                        </div>
                        <p style="color: green; font-size: 16px; font-weight: bold;">R$ {{ item.valorTotal.toFixed(2).replace(".", ",") }}</p>
                    </div>
                </div>

            </div>

            <div style="display: flex; flex-direction: column; gap: 10px; padding: 25px;" v-if="mensagemDeErro != null">
                <div v-for="(item, index) in this.mensagemDeErro" :key="index" style="color: red">
                    <p>{{ item }}</p>
                </div>
            </div>

        </div>


        <!-- <div style="position: absolute; z-index: 100; height: 100dvh; width: 100dvw; top: 50px; left: 0" @touchstart="tocouNaTela" > -->

        <!-- </div> -->
    </section>
</template>

<script>
import { setarCores } from '@/utils/SetarCores'
import { apiSincronizacao } from "../api/ApiSincronizacao"
import { apiAbriuTelaConta, apiBuscarItensDaConta, apiBuscarStatusMesa, apiFechouTelaConta } from '@/api/ApiPegarMesa'
import MenuTopTemplate from '@/components/Base/MenuTopTemplate.vue'
import CameraScanner from '@/utils/CameraScanner.vue'

export default {
    components: { MenuTopTemplate, CameraScanner},
    name: "ContaView",
    data() {
        return {
            loading: false,
            dadosConta: {},
            mesa:"",
            valor:"",
            desconto_comanda:null,
            status:"",
            numeroCartao: null,
            porCartao: this.$store.state.porCartao,
            habilitarCodeScanner:false,
            mensagemDeErro: null,
            iconeWallet: require('../assets/icons/ic-wallet.svg'),
            timer: 60,
            
            estouChamandofechouTela: false, // para nao chamar fechouTela() duas vezes ao mesmo tempo
            jaFechouTela: false, // para parar o clock do buscar itens
            // aqui vao ficar os itens
            itensDaConta: null,
            loadingItens: true,
            

            numeroCartaoDigitado:null
        }
    },

    created() {
        if (this.porCartao) {
            this.habilitarCodeScanner=true;
        } else {
            this.refreshStatus(null)
        } 
        setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto)
        this.confirmarVariaveisIniciais()
        this.comecarTimerDeToqueNaTela()
    },
    
    computed: {
        tituloConta() {
            if (this.porCartao) {
                return 'CONTA DA COMANDA'
            }
            return 'CONTA DA MESA ' + this.$store.state.mesa
        },
        valorArrumado() {
            if (this.valor == null) {
                return "0,00"
            } else if (this.valor == 0) {
                return "0,00"  
            } else {
                return this.valor.toFixed(2).replace(".", ",")
            }
        },
        descontoComandaArrumado() {
            if (this.desconto_comanda == null) {
                return null
            } else if (this.desconto_comanda == 0) {
                return null 
            } else {
                return this.desconto_comanda.toFixed(2).replace(".", ",")
            }
        }
    },


    beforeDestroy() {
        if (this.timer > 0) {
            this.fechouTela("beforeDestroy")
        }
        this.confirmarVariaveisIniciais();
    },

    methods: {

        confirmarVariaveisIniciais() {
            this.timer = 60;
            this.mensagemDeErro = null;
        },

        comecarTimerDeToqueNaTela() {
            if (this.timer > 0) {
                setTimeout(() => {
                    this.timer = this.timer - 1
                    if (document.URL.includes("conta")) {
                        this.comecarTimerDeToqueNaTela()
                    }
                }, 1000);
            } else {
                this.confirmarVariaveisIniciais()
                this.fechouTela("comecarTimerDeToqueNaTela")
                this.$router.back();
            }
        },

        tocouNaTela() {
            this.timer = 60
        },

        /** quando o usuario fecha essa t3e4cla essa funcao vai ser camada (no @see beforeDestroy ). Precisamos dsbloquear a comanda */
        fechouTela(deOndeVenho) {
            this.jaFechouTela=true

            // so vamos mandar a operacao de desbloqueio caso nao esteja aberta em outro terminal, senao vai desbloquear a comadna memso estando aberta em outro terminal
            // e para fazer essa verificacao, vemos se @see mensagemDeErro == null
            
            console.log(`%c ENVIADO PRO BACK -- mensagem de erro  = ${this.mensagemDeErro} -- e venho de : ${deOndeVenho}`, "background: yellow")
            
            if (this.mensagemDeErro == null && this.estouChamandofechouTela == false) { 
                console.log(`%c ENVIEI!  = ${this.mensagemDeErro}`, "background: red")
                this.estouChamandofechouTela = true;

                let json = {
                    cnpj: this.$store.state.cnpj,
                    idTerminal: this.$store.state.idTerminal,
                    operacao: 24, // operacao de desbloqueio
                    NumeroCMS_FK: this.numeroCartao ?? this.$store.state.mesa,
                    mesa: this.$store.state.mesa,
                    // tipo: this.motivo,
                    IdGarcons_FK: this.$store.state.idgarcom,
                    CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                    idCaixaLio: this.$store.state.idTerminal,
                    numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                    // tipo: this.numeroCartao ? "cartao" : null,
                    tipo: this.$store.state.porCartao ? "cartao" : "mesa",
                    cartao: this.numeroCartao || null,
                }
                
                console.log("fechanbdo tela")
                apiFechouTelaConta(json).then((res) => {
                    console.log(res)
                }).finally(() => {
                    this.estouChamandofechouTela = false;
                })
            }
        },

        onBarcodeLido(val){
            console.log("Peguei o numero do cartao:"+val);
            this.numeroCartao=val;
            this.refreshStatus(val);
            this.habilitarCodeScanner=false;
        },
        test() {
            // let dadosUrl = {cnpj: this.$store.state.cnpj, idTerminal: this.$store.state.idTerminal};
            apiSincronizacao( this.$store.state.cnpj, this.$store.state.idTerminal);
        },

        /**
         * o numero pode ser nulo, indicando que estamos usando MESA
         * ou um integer que indica que estamos usando CARTAO
         * 
         * essa funcao vai tratar isso
         * @param {integer} numero 
         */
        refreshStatus(numero) {
            this.loading = true;

            apiBuscarStatusMesa(this.$store.state.cnpj, this.$store.state.idTerminal, this.$store.state.numeroEmpresaFK, numero).then((res) => {
                this.$store.dispatch("setStatusEConta", {statusMesa: res.status, totalContaMesa: res.valor_total});
                this.mesa = res.numero_mesa;
                this.status = res.status;
                this.valor = res.valor_total;
                this.desconto_comanda = res.desconto_comanda;
                this.mensagemDeErro = null;

                
                console.log("refreshStatus", numero)
                console.log(res)

                this.buscarItensDaConta(numero);
                this.loading = false;
            });
        },

        /**
         * 
         * @param numeroDoCartao caso estejamos trabalhando por cartao, senao esse param vira nulo
         */
        buscarItensDaConta(numeroDoCartao) {
            console.log("aqiu vem o numero do cartao", numeroDoCartao)
            // if (this.status.toLowerCase() != "conta" && this.status.toLowerCase() != "aberta" &&  this.status.toLowerCase() != this.$store.state.nomeTerminal.toLowerCase()) {
            if ( this.status.toLowerCase() == "livre") {
                     // se o status for livre nao vamos fazer nada
                this.loadingItens = false
            } else if (this.status.toLowerCase() != "conta" && this.status.toLowerCase() != "aberta" ) {
                this.loadingItens = false
                this.mensagemDeErro = [
                    'Comanda aberta em outro terminal',
                    `Terminal ${this.status}`,
                    'Não é possível ver a conta. Por favor, chame um garçom.`'
                ];           
                
            } else {

                let json = {
                    cnpj: this.$store.state.cnpj,
                    idTerminal: this.$store.state.idTerminal,
                    operacao: 2, // operacao de bloqueio
                    NumeroCMS_FK: numeroDoCartao ?? this.$store.state.mesa,
                    mesa: this.$store.state.mesa,
                    IdGarcons_FK: this.$store.state.idgarcom, 
                    CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                    idCaixaLio: this.$store.state.idTerminal,
                    numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                    tipo: numeroDoCartao ? "cartao" : null,
                    cartao: numeroDoCartao || null,
                }

                this.loadingItens = true
                apiAbriuTelaConta(json).then((res) => {
                    console.log("abriu tela conta e inseriu operacao 2")
                    console.log(res)
                    this.apiBuscarItensComCiclo()
                })
            }
        },


        apiBuscarItensComCiclo() {
            let json = {
                cnpj: this.$store.state.cnpj,
                idTerminal: this.$store.state.idTerminal,
                operacao: 2, // operacao de bloqueio
                NumeroCMS_FK:  this.numeroCartao ?? this.$store.state.mesa,
                mesa: this.$store.state.mesa,
                IdGarcons_FK: this.$store.state.idgarcom, 
                CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                idCaixaLio: this.$store.state.idTerminal,
                numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                tipo: this.numeroCartao ? "cartao" : null,
                cartao: this.numeroCartao || null,
            }

            setTimeout(() => {
                apiBuscarItensDaConta(json)
                .then((res) => {
                    console.log("resultado aqui")
                    console.log(res)

                    if (res.length > 0) {
                        this.itensDaConta = res;
                        this.loadingItens = false
                    } else {
                        if (this.jaFechouTela == false) {
                            this.apiBuscarItensComCiclo()
                        }
                    }
                    })
            }, 1000);
        },

        voltar() {
            this.$router.back();
        },
    }
}
</script>

<style scoped>

.coluna {display: block; width: 50%;}

.coluna p {font-size: 12px; color: black;}

.coluna h5 {font-size: 14px; color: black;}

</style>